import { render } from "./OrderContainer.vue?vue&type=template&id=19a8db50"
import script from "./OrderContainer.vue?vue&type=script&lang=js"
export * from "./OrderContainer.vue?vue&type=script&lang=js"

import "./OrderContainer.vue?vue&type=style&index=0&id=19a8db50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__